var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.event
    ? _c("div", { staticClass: "event-stats" }, [
        _c("h1", [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Stats")))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "provider" }, [
            _vm._v(_vm._s(_vm.$t("PoweredBy")) + " "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("Number"))),
              _c("strong", [_vm._v(_vm._s(_vm.$t("Fire")))])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.statsAvailable
          ? _c("div", { staticClass: "stats-data" }, [
              _c(
                "div",
                {
                  staticClass: "record head",
                  class: { "team-logos": _vm.teamLogoVisibility }
                },
                [
                  _c("div", { staticClass: "away cell" }, [
                    _vm.showparticipantlogo
                      ? _c("span", {
                          staticClass: "team-logo",
                          style: _vm.awayTeamLogoStyle
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.nameAway))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "time-location cell" }, [
                    _c("span", { staticClass: "at" }, [_vm._v("@")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "date" }, [
                      _vm._v(_vm._s(_vm.date))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "time" }, [
                      _vm._v(_vm._s(_vm.time))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "location" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "home cell" }, [
                    _vm.showparticipantlogo
                      ? _c("span", {
                          staticClass: "team-logo",
                          style: _vm.homeTeamLogoStyle
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.nameHome))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "record result" }, [
                _c("div", { staticClass: "away cell" }, [
                  _vm._v(_vm._s(_vm.awayParticipantAgainstTheSpreadRecord))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description cell" }, [
                  _vm._v(_vm._s(_vm.$t("Stats.AgainstTheSpreadRecord")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "home cell" }, [
                  _vm._v(_vm._s(_vm.homeParticipantAgainstTheSpreadRecord))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "record result" }, [
                _c("div", { staticClass: "away cell" }, [
                  _vm._v(_vm._s(_vm.awayParticipantStatsWhenPlayingAway))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description cell" }, [
                  _vm._v(_vm._s(_vm.$t("Stats.HomeVsAwayRecord")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "home cell" }, [
                  _vm._v(_vm._s(_vm.homeParticipantStatsWhenPlayingHome))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "record result" }, [
                _c("div", { staticClass: "away cell" }, [
                  _vm._v(_vm._s(_vm.awayParticipantWinProbability))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description cell" }, [
                  _vm._v(_vm._s(_vm.$t("Stats.WinProbability")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "home cell" }, [
                  _vm._v(_vm._s(_vm.homeParticipantWinProbability))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "record result" }, [
                _c("div", { staticClass: "away cell" }, [
                  _vm._v(_vm._s(_vm.awayParticipantOverUnderRecord))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description cell" }, [
                  _vm._v(_vm._s(_vm.$t("Stats.OverUnderRecord")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "home cell" }, [
                  _vm._v(_vm._s(_vm.homeParticipantOverUnderRecord))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "record result" }, [
                _c("div", { staticClass: "away cell" }, [
                  _vm._v(_vm._s(_vm.awayParticipantAveragePointsForPerGame))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description cell" }, [
                  _vm._v(_vm._s(_vm.$t("Stats.AveragePointsForPerGame")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "home cell" }, [
                  _vm._v(_vm._s(_vm.homeParticipantAveragePointsForPerGame))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "record result" }, [
                _c("div", { staticClass: "away cell" }, [
                  _vm._v(_vm._s(_vm.awayParticipantAveragePointsAgainstPerGame))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description cell" }, [
                  _vm._v(_vm._s(_vm.$t("Stats.AveragePointsAgainstPerGame")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "home cell" }, [
                  _vm._v(_vm._s(_vm.homeParticipantAveragePointsAgainstPerGame))
                ])
              ])
            ])
          : _c("div", { staticClass: "stats-data no-stats" }, [
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("NoStats")))
              ])
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6b7ede0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6b7ede0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cdu/EventStats.vue
// module id = null
// module chunks = 